import { PARAM_EXC_LOGIN, OMEGA_SCRIPT_STAGE, OMEGA_SCRIPT_PROD } from '../constants/genericConstants';

export function initializeEnvironmentVariables() {
    let host = window.location.host;
    let envVar = {};
    let tenantId = '';
    if (host.includes('experience-qa.corp.adobe.com')) {
        envVar = require('./../config/config.json').qa;
        if (host == 'experience-qa.corp.adobe.com') {
            tenantId = '';
        } else {
            tenantId = host.replace('.experience-qa.corp.adobe.com', '');
        }
        envVar.TENANT_ID = tenantId;
        envVar.EXC_LOGIN_URL = envVar.PROTOCOL_SCHEME + PARAM_EXC_LOGIN + '.' + envVar.EXC_SESSION_HOST + '/';
        envVar.OMEGA_SCRIPT_SRC = OMEGA_SCRIPT_STAGE;
    } else if (host.includes('experiencecloud-stage.adobe.com')) {
        envVar = require('./../config/config.json').stage;
        if (host == 'experiencecloud-stage.adobe.com') {
            tenantId = '';
        } else {
            tenantId = host.replace('.experiencecloud-stage.adobe.com', '');
        }
        envVar.TENANT_ID = tenantId;
        envVar.EXC_LOGIN_URL = envVar.PROTOCOL_SCHEME + PARAM_EXC_LOGIN + '.' + envVar.EXC_SESSION_HOST + '/';
        envVar.OMEGA_SCRIPT_SRC = OMEGA_SCRIPT_STAGE;
    } else if (host.includes('experiencecloud.adobe.com')) {
        envVar = require('./../config/config.json').prod;
        if (host == 'experiencecloud.adobe.com') {
            tenantId = '';
        } else {
            tenantId = host.replace('.experiencecloud.adobe.com', '');
        }
        envVar.TENANT_ID = tenantId;
        envVar.EXC_LOGIN_URL = envVar.PROTOCOL_SCHEME + PARAM_EXC_LOGIN + '.' + envVar.EXC_SESSION_HOST + '/';
        envVar.OMEGA_SCRIPT_SRC = OMEGA_SCRIPT_PROD;
    } else if (host.includes('marketing-qe1.adobemc.com')) {
        envVar = require('./../config/config.json').perf;
        if (host == 'marketing-qe1.adobemc.com') {
            tenantId = '';
        } else {
            tenantId = host.replace('.marketing-qe1.adobemc.com', '');
        }
        envVar.TENANT_ID = tenantId;
        envVar.EXC_LOGIN_URL = envVar.PROTOCOL_SCHEME + PARAM_EXC_LOGIN + '.' + envVar.EXC_SESSION_HOST + '/';
        envVar.OMEGA_SCRIPT_SRC = OMEGA_SCRIPT_STAGE;
    } else {
        envVar = require('./../config/config.json').default;
        envVar.EXC_SESSION_DOMAIN = window.location.origin;
        envVar.EXC_SESSION_HOST = host;
        envVar.LOGIN_SERVICE_ENDPOINT = window.location.origin;
        envVar.LOGIN_SERVICE_IMS_ENDPOINT = window.location.origin;
        envVar.IMS_CLIENT_ID = 'MarketingCloud11_qa';
        envVar.TENANT_ID = '';
        envVar.EXC_LOGIN_URL = envVar.EXC_SESSION_DOMAIN;
        envVar.OMEGA_SCRIPT_SRC = OMEGA_SCRIPT_STAGE;
    }

    let commonJson = require('./../config/config.json').common;
    envVar.EXC_SESSION_IMSLOGIN_URL = commonJson.EXC_SESSION_IMSLOGIN_URL;
    envVar.EXC_SESSION_VALIDATE_URL = commonJson.EXC_SESSION_VALIDATE_URL;
    envVar.EXC_SESSION_IMSSSO_HANDLER = commonJson.EXC_SESSION_IMSSSO_HANDLER;
    return envVar;
}



// WEBPACK FOOTER //
// ./src/utils/envUtil.js